import React from 'react';
import './HamburgerIcon.css';

interface HamburgerIconProps {
  onClick: () => void;
  className?: string;
}

const HamburgerIcon = React.forwardRef<HTMLButtonElement, HamburgerIconProps>(
  ({ onClick, className = '' }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={`hamburger-icon ${className}`}
        onClick={onClick}
        aria-label="Open menu"
      >
        <span className="hamburger-line" aria-hidden />
        <span className="hamburger-line" aria-hidden />
        <span className="hamburger-line" aria-hidden />
      </button>
    );
  },
);

HamburgerIcon.displayName = 'HamburgerIcon';

export default HamburgerIcon;
